import { Highlight } from 'react-instantsearch-dom'
import TrackingLink from '../../link/tracking-link'

import ContentType from './ContentType'

const SearchResult = (props) => {
  const { hit, isHighlited, track, gaEvents, type } = props

  return <li
    className='algolia-search-result'
    style={{ backgroundColor: isHighlited ? '#F2F2F2' : null }}
    {...props}
  >
    <TrackingLink target={type === 'zendesk' ? '_blank' : ''} href={hit.topic_url} track={track} gaEvents={gaEvents} className='algolia-hit-item button-click'>
      <span className='algolia-hit-item--name'>
        <Highlight attribute='title' hit={hit} tagName='strong' />
        <span className='hit-item--meta'>
          <ContentType
            contentType={hit.content_type}
            articleLabel={hit.article_label}
            hasAnswer={hit.has_answer}
          />
        </span>
      </span>
    </TrackingLink>
  </li>
}

export default SearchResult
